import { useTranslate } from "@made-people/grease-translations";
import { Cross } from "../../../assets/icons/Cross";
import { Info } from "../../../assets/icons/Info";

export const FeatureNotice = (props: { onClose: () => void }) => {
  const translate = useTranslate();

  return (
    <div className="relative flex flex-row gap-3 rounded-md bg-[#E6F1F7] px-6 py-4 text-left text-body-sm">
      <Info className="mt-1 h-4 w-4 shrink-0" />
      <span>{translate("Customisation_Popup_Feature_Notice")}</span>
      <button className="ml-auto" onClick={props.onClose}>
        <Cross className="h-4 w-4" />
      </button>
    </div>
  );
};
